<div id="isd_container">
  @if (insufficientInstanceAmount > 0) {
    <div class="inner_container">
      Fehler
      @if (selectedInstance) {
        <div id="selectedInstance">
          <h3>Ungenügend Daten für {{ getSelectedInstanceName() }}</h3>
          @if (hawkLink) {
            <p>Hawk-Link: <a [href]="hawkLink" target="_blank">hier</a></p>
          }
          <p>Bitte geben Sie eine gültige Adresse (inkl. Koordinaten) an!</p>
          <div id="ins_data_geocoder"></div>
          <br />
          <button [disabled]="!selectedInstanceIsReadyToUpdate()" (click)="updateSelectedInstance()">
            Adresse updaten
          </button>
        </div>
      }
    </div>
  }

  @if (insufficientInstanceAmount == 0) {
    <div class="inner_container">Alles erledigt!</div>
  }
</div>
